import { OrderDetailsPage } from "@app/features/order-details";
import { LogoTopBar } from "@app/shared/layout";

/**
 * Desktop's root/"Main" screen (see `HomeRoute`). The mobile `HomePage`
 * (full-screen map + floating chrome) doesn't apply once the map has its
 * own permanent pane on the right — `DesktopTrackingShell` renders it
 * there instead, so the left panel goes straight to the info-rich hub page
 * (`OrderDetailsPage`, reused as-is) with its back-button header swapped
 * for the tenant logo, since there's nowhere to go "back" to from the root.
 */
export const DesktopHomePage = () => (
  <OrderDetailsPage
    renderHeader={({ order, isDropoffTracking }) => (
      <LogoTopBar logoUrl={order?.logoUrl ?? ""} orderCode={order?.code} isDropoffTracking={isDropoffTracking} />
    )}
  />
);
